import script from "./TrophyCabinet.vue?vue&type=script&setup=true&lang=js"
export * from "./TrophyCabinet.vue?vue&type=script&setup=true&lang=js"

import "./TrophyCabinet.vue?vue&type=style&index=0&id=676aeb5f&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676aeb5f"]])

export default __exports__